/* ==========================================================================
   3Habitos · Futura — movimiento e interacción
   Sin dependencias salvo Lenis (scroll suave con inercia, assets/lenis.min.js).
   Solo se animan transform y opacity. Todo funciona sin este archivo.
   ========================================================================== */
(function () {
  'use strict';

  var d = document;
  var root = d.documentElement;
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqFine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var mqSmall = window.matchMedia('(max-width: 700px)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var lenis = null;

  function reduce() { return mqReduce.matches; }
  function fine() { return mqFine.matches && !reduce(); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function $(sel, ctx) { return (ctx || d).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function safe(name, fn) {
    try { fn(); } catch (err) { if (window.console) console.warn('[3Habitos] ' + name + ':', err); }
  }
  function once(el, key) {
    if (el['__h3' + key]) return false;
    el['__h3' + key] = true;
    return true;
  }
  function headerOffset() {
    var h = $('[data-header]');
    return (h ? h.offsetHeight : 68) + 8;
  }

  /* ---------- Bucle único de animación ---------- */
  var tickers = [];
  var scroll = { y: window.pageYOffset, v: 0, last: window.pageYOffset };
  function onTick(fn) { tickers.push(fn); }
  function frame(t) {
    if (lenis) lenis.raf(t);
    var y = window.pageYOffset;
    scroll.v = lerp(scroll.v, y - scroll.last, 0.25);
    scroll.last = y;
    scroll.y = y;
    for (var i = 0; i < tickers.length; i++) tickers[i](t);
    window.requestAnimationFrame(frame);
  }

  /* ---------- Apariciones al hacer scroll ---------- */
  var revealIO = null;
  function initReveal(scope) {
    var els = $$('[data-reveal], [data-decode], [data-pack], [data-count]', scope);
    if (reduce() || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); fireIn(el); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          fireIn(e.target);
          revealIO.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { revealIO.observe(el); });
  }
  function fireIn(el) {
    if (el.hasAttribute('data-decode')) decode(el);
    if (el.hasAttribute('data-count')) countUp(el);
    if (el.hasAttribute('data-pack')) {
      window.setTimeout(function () { $$('[data-money-to]', el).forEach(moneyCount); }, reduce() ? 0 : 650);
    }
  }

  /* ---------- Titular que se descodifica letra a letra ---------- */
  var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&@$*<>/+=';
  var ACCENT_STOPS = [[0, [127, 220, 120]], [0.45, [211, 207, 74]], [0.7, [242, 179, 61]], [1, [240, 138, 75]]];
  function accentColor(t) {
    for (var i = 1; i < ACCENT_STOPS.length; i++) {
      var a = ACCENT_STOPS[i - 1], b = ACCENT_STOPS[i];
      if (t <= b[0]) {
        var k = (t - a[0]) / (b[0] - a[0]);
        return 'rgb(' + a[1].map(function (v, j) { return Math.round(v + (b[1][j] - v) * k); }).join(',') + ')';
      }
    }
    return 'rgb(' + ACCENT_STOPS[ACCENT_STOPS.length - 1][1].join(',') + ')';
  }
  function splitDecode(el) {
    if (!once(el, 'split') || reduce()) return;
    var text = el.textContent.trim();
    var accentEl = el.querySelector('.hero__accent');
    var accentCount = accentEl ? accentEl.textContent.trim().split(/\s+/).length : 0;
    var accentChars = [];
    var sr = d.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = text;
    var vis = d.createElement('span');
    vis.setAttribute('aria-hidden', 'true');
    text.split(/\s+/).forEach(function (word, wi, arr) {
      var w = d.createElement('span');
      w.className = 'dc-word';
      w.style.setProperty('--wd', (wi * 0.07).toFixed(2) + 's');
      var isAccent = wi >= arr.length - accentCount;
      Array.prototype.forEach.call(word, function (ch) {
        var c = d.createElement('span');
        c.className = 'dc-char';
        c.textContent = ch;
        if (isAccent) accentChars.push(c);
        w.appendChild(c);
      });
      vis.appendChild(w);
      if (wi < arr.length - 1) vis.appendChild(d.createTextNode(' '));
    });
    // Degradado letra a letra (verde → ámbar → naranja) en las últimas palabras
    accentChars.forEach(function (c, i) {
      var col = accentColor(accentChars.length > 1 ? i / (accentChars.length - 1) : 0);
      c.style.color = col;
      c.style.webkitTextFillColor = col;
    });
    el.textContent = '';
    el.appendChild(sr);
    el.appendChild(vis);
  }
  function decode(el) {
    if (reduce()) return;
    var chars = $$('.dc-char', el);
    var start = performance.now();
    chars.forEach(function (c, i) {
      c.__start = start + i * 28;
      c.__end = c.__start + 380 + Math.random() * 260;
      if (/\S/.test(c.textContent)) c.classList.add('is-scrambling');
    });
    var n = 0;
    (function step(now) {
      var active = false;
      n++;
      chars.forEach(function (c) {
        if (!c.classList.contains('is-scrambling')) return;
        if (now >= c.__end) { c.classList.remove('is-scrambling'); return; }
        active = true;
        if (n % 3 === 0) c.setAttribute('data-g', GLYPHS[(Math.random() * GLYPHS.length) | 0]);
      });
      if (active) window.requestAnimationFrame(step);
    })(start);
  }

  /* ---------- Contadores ---------- */
  function easeOut(t) { return 1 - Math.pow(1 - t, 4); }
  function countUp(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    if (reduce() || isNaN(target) || String(target) !== el.getAttribute('data-count').trim()) return;
    var dur = 1400, t0 = performance.now();
    el.style.fontVariantNumeric = 'tabular-nums';
    (function step(now) {
      var p = clamp((now - t0) / dur, 0, 1);
      el.textContent = Math.round(target * easeOut(p));
      if (p < 1) window.requestAnimationFrame(step);
    })(t0);
  }
  function moneyCount(el) {
    var from = parseInt(el.getAttribute('data-money-from'), 10);
    var to = parseInt(el.getAttribute('data-money-to'), 10);
    var finalText = el.textContent;
    if (reduce() || isNaN(from) || isNaN(to) || from === to) return;
    var host = el.closest('[data-currency]');
    var currency = (host && host.getAttribute('data-currency')) || 'EUR';
    var fmt;
    try { fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: currency }); } catch (e) { return; }
    var dur = 1500, t0 = performance.now();
    (function step(now) {
      var p = clamp((now - t0) / dur, 0, 1);
      var v = from + (to - from) * easeOut(p);
      el.textContent = fmt.format(Math.round(v) / 100);
      if (p < 1) window.requestAnimationFrame(step);
      else el.textContent = finalText;
    })(t0);
  }

  /* ---------- Scroll suave con inercia (Lenis) y anclas ---------- */
  function initSmooth() {
    if (!reduce() && !designMode && typeof window.Lenis === 'function') {
      lenis = new window.Lenis({ lerp: 0.085, smoothWheel: true, wheelMultiplier: 1 });
    }
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey) return;
      var url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname || !url.hash || url.hash === '#') return;
      var target = d.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!target) return;
      e.preventDefault();
      var menu = $('[data-menu]');
      if (menu) menu.open = false;
      scrollToEl(target);
      if (history.replaceState) history.replaceState(null, '', url.hash);
    });
  }
  function scrollToEl(target) {
    var focusIt = function () {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    };
    if (lenis) {
      lenis.scrollTo(target, { offset: -headerOffset(), duration: 1.4, onComplete: focusIt });
    } else {
      var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: y, behavior: reduce() ? 'auto' : 'smooth' });
      window.setTimeout(focusIt, reduce() ? 0 : 700);
    }
  }

  /* ---------- Barra de progreso, cabecera y rejilla ---------- */
  function initChrome() {
    var bar = $('[data-progress]');
    var header = $('[data-header]');
    var grid = $('[data-bg-grid]');
    var menu = $('[data-menu]');
    var lastY = window.pageYOffset, hidden = false, gridSkew = 0;
    onTick(function () {
      var y = scroll.y;
      var max = root.scrollHeight - window.innerHeight;
      if (bar) bar.style.transform = 'scaleX(' + (max > 0 ? clamp(y / max, 0, 1) : 0).toFixed(4) + ')';
      if (header) {
        var dy = y - lastY;
        var small = window.innerWidth < 900;
        var shouldHide = small && y > 140 && dy > 2 && !(menu && menu.open);
        var shouldShow = dy < -2 || y < 140 || !small || (menu && menu.open);
        if (shouldHide && !hidden) { header.classList.add('is-hidden'); hidden = true; }
        else if (shouldShow && hidden) { header.classList.remove('is-hidden'); hidden = false; }
        lastY = y;
      }
      if (grid && !reduce()) {
        gridSkew = lerp(gridSkew, clamp(scroll.v * 0.004, -0.08, 0.08), 0.1);
        grid.style.transform = 'translate3d(0,' + (-(y * 0.12) % 64).toFixed(2) + 'px,0) scaleY(' + (1 + Math.abs(gridSkew)).toFixed(4) + ')';
      }
    });
    if (menu) {
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); } });
      d.addEventListener('click', function (e) { if (menu.open && !menu.contains(e.target)) menu.open = false; });
    }
    var links = $$('.nav__link');
    if (links.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (l) { l.classList.toggle('is-active', l.hash === '#' + e.target.id); });
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      ['casos', 'ebooks', 'preguntas'].forEach(function (id) { var s = d.getElementById(id); if (s) io.observe(s); });
    }
  }

  /* ---------- Cursor personalizado (solo ratón) ---------- */
  function initCursor() {
    if (!fine()) return;
    var wrap = d.createElement('div');
    wrap.className = 'cursor';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML = '<span class="cursor__ring"><span class="cursor__ring-scale"></span></span><span class="cursor__dot"></span>';
    d.body.appendChild(wrap);
    root.classList.add('has-cursor');
    var ring = $('.cursor__ring', wrap), dot = $('.cursor__dot', wrap), scale = $('.cursor__ring-scale', wrap);
    var x = -100, y = -100, rx = -100, ry = -100, big = false;
    var hot = 'a, button, summary, [data-magnetic], input[type="range"], [data-marquee]';
    d.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      var isHot = !!(e.target.closest && e.target.closest(hot));
      if (isHot !== big) {
        big = isHot;
        scale.style.transform = big ? 'scale(1.8)' : 'scale(1)';
        scale.style.borderColor = big ? 'rgba(232,100,31,.8)' : '';
      }
    }, { passive: true });
    d.addEventListener('pointerdown', function () { scale.style.transform = 'scale(0.75)'; });
    d.addEventListener('pointerup', function () { scale.style.transform = big ? 'scale(1.8)' : 'scale(1)'; });
    d.documentElement.addEventListener('mouseleave', function () { wrap.style.opacity = '0'; });
    d.documentElement.addEventListener('mouseenter', function () { wrap.style.opacity = '1'; });
    onTick(function () {
      rx = lerp(rx, x, 0.2); ry = lerp(ry, y, 0.2);
      dot.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      ring.style.transform = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0)';
    });
  }

  /* ---------- Botones magnéticos e inclinación 3D ---------- */
  function initMagnetic(scope) {
    if (!fine()) return;
    $$('[data-magnetic]', scope).forEach(function (el) {
      if (!once(el, 'mag')) return;
      el.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = el.getBoundingClientRect();
        var mx = clamp((e.clientX - (r.left + r.width / 2)) * 0.28, -14, 14);
        var my = clamp((e.clientY - (r.top + r.height / 2)) * 0.38, -10, 10);
        el.style.setProperty('--mx', mx.toFixed(1) + 'px');
        el.style.setProperty('--my', my.toFixed(1) + 'px');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--mx', '0px');
        el.style.setProperty('--my', '0px');
      });
    });
  }
  function initTilt(scope) {
    if (!fine()) return;
    $$('[data-tilt]', scope).forEach(function (el) {
      if (!once(el, 'tilt')) return;
      el.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        el.style.setProperty('--ry', ((px - 0.5) * 12).toFixed(2) + 'deg');
        el.style.setProperty('--rx', ((0.5 - py) * 10).toFixed(2) + 'deg');
        el.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--ry', '0deg');
        el.style.setProperty('--rx', '0deg');
      });
    });
  }

  /* ---------- Portada: parallax por capas (ratón + scroll) ---------- */
  function initParallax(scope) {
    if (reduce()) return;
    $$('[data-parallax]', scope).forEach(function (scene) {
      if (!once(scene, 'plx')) return;
      var layers = $$('[data-depth]', scene).map(function (el) { return { el: el, depth: parseFloat(el.getAttribute('data-depth')) || 0.5 }; });
      var tx = 0, ty = 0, cx = 0, cy = 0, visible = true;
      if (fine()) {
        window.addEventListener('pointermove', function (e) {
          if (e.pointerType !== 'mouse') return;
          tx = (e.clientX / window.innerWidth) * 2 - 1;
          ty = (e.clientY / window.innerHeight) * 2 - 1;
        }, { passive: true });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(scene);
      }
      onTick(function () {
        if (!visible) return;
        cx = lerp(cx, tx, 0.06); cy = lerp(cy, ty, 0.06);
        var sy = scroll.y;
        for (var i = 0; i < layers.length; i++) {
          var L = layers[i];
          var s = L.el.style;
          s.setProperty('--px', (cx * L.depth * 30).toFixed(2));
          s.setProperty('--py', (cy * L.depth * 22).toFixed(2));
          s.setProperty('--sy', (-sy * L.depth * 0.22).toFixed(1) + 'px');
          s.setProperty('--tilt-y', (cx * 10 * L.depth).toFixed(2));
          s.setProperty('--tilt-x', (-cy * 8 * L.depth).toFixed(2));
        }
      });
    });
  }

  /* ---------- Casos: carrusel infinito arrastrable con inercia ---------- */
  function initMarquee(scope) {
    $$('[data-marquee]', scope).forEach(function (wrap) {
      var track = $('[data-marquee-track]', wrap);
      if (!track || !once(wrap, 'mq')) return;
      initCompare(wrap);
      if (reduce() || track.children.length === 0) return;

      var originals = Array.prototype.slice.call(track.children);
      var setWidth = 0;
      function measure() {
        // Quita clones previos y vuelve a clonar hasta cubrir el doble del ancho visible
        $$('[data-clone]', track).forEach(function (c) { c.remove(); });
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        setWidth = originals.reduce(function (sum, el) { return sum + el.offsetWidth + gap; }, 0);
        if (!setWidth) return;
        var copies = Math.max(1, Math.ceil((window.innerWidth * 2) / setWidth));
        for (var c = 0; c < copies; c++) {
          originals.forEach(function (el) {
            var clone = el.cloneNode(true);
            clone.setAttribute('data-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('inert', '');
            $$('[id]', clone).forEach(function (n) { n.removeAttribute('id'); });
            $$('input, a, button', clone).forEach(function (n) { n.setAttribute('tabindex', '-1'); });
            track.appendChild(clone);
          });
        }
        initCompare(track);
      }
      wrap.classList.add('is-live');
      measure();

      var x = 0, v = 0, auto = 0.5, speed = auto, paused = false, dragging = false, visible = true, skew = 0;
      var startX = 0, lastX = 0, lastT = 0, moved = 0;

      wrap.addEventListener('mouseenter', function () { paused = true; });
      wrap.addEventListener('mouseleave', function () { paused = false; });
      wrap.addEventListener('focusin', function () { paused = true; });
      wrap.addEventListener('focusout', function () { paused = false; });

      wrap.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 || (e.target.closest && e.target.closest('.ba'))) return;
        dragging = true; moved = 0;
        startX = lastX = e.clientX; lastT = performance.now(); v = 0;
        wrap.setPointerCapture(e.pointerId);
        wrap.classList.add('is-dragging');
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var now = performance.now();
        var dx = e.clientX - lastX;
        x += dx;
        moved += Math.abs(dx);
        v = dx / Math.max(1, now - lastT) * 16;
        lastX = e.clientX; lastT = now;
      });
      function end(e) {
        if (!dragging) return;
        dragging = false;
        wrap.classList.remove('is-dragging');
        if (e && wrap.hasPointerCapture && wrap.hasPointerCapture(e.pointerId)) wrap.releasePointerCapture(e.pointerId);
      }
      wrap.addEventListener('pointerup', end);
      wrap.addEventListener('pointercancel', end);
      wrap.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { v = -18; e.preventDefault(); }
        if (e.key === 'ArrowLeft') { v = 18; e.preventDefault(); }
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(wrap);
      }
      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(measure, 200); });

      var prev = performance.now();
      onTick(function (now) {
        var dt = clamp((now - prev) / 16.67, 0, 3); prev = now;
        if (!visible || !setWidth) return;
        speed = lerp(speed, paused || dragging ? 0 : auto, 0.06);
        if (!dragging) {
          x += v * dt;
          v *= Math.pow(0.94, dt);
          if (Math.abs(v) < 0.02) v = 0;
          x -= speed * dt;
        }
        if (x <= -setWidth) x += setWidth;
        if (x > 0) x -= setWidth;
        skew = lerp(skew, clamp(-scroll.v * 0.25 + v * 0.25, -7, 7), 0.12);
        track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
        track.style.setProperty('--skew', skew.toFixed(2) + 'deg');
      });
    });
  }

  /* Comparador antes/después */
  function initCompare(scope) {
    $$('[data-ba]', scope).forEach(function (ba) {
      if (!once(ba, 'ba')) return;
      var range = $('.ba__range', ba);
      if (!range) return;
      var set = function () { ba.style.setProperty('--p', range.value); };
      range.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Catálogo: scroll horizontal fijado ---------- */
  function initHScroll(scope) {
    $$('[data-hscroll]', scope).forEach(function (sec) {
      var track = $('[data-hscroll-track]', sec);
      var sticky = $('.catalog__sticky', sec);
      if (!track || !once(sec, 'hs')) return;
      var distance = 0, on = false, top = 0;
      function setup() {
        var want = window.innerWidth >= 1024 && !reduce();
        sec.classList.toggle('is-pinned', want);
        track.style.transform = '';
        if (!want) { on = false; sec.style.removeProperty('--hs-distance'); return; }
        distance = Math.max(0, track.scrollWidth - window.innerWidth);
        if (distance < 40) { sec.classList.remove('is-pinned'); on = false; return; }
        sec.style.setProperty('--hs-distance', distance + 'px');
        top = sec.getBoundingClientRect().top + window.pageYOffset;
        on = true;
      }
      setup();
      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(setup, 150); });
      window.addEventListener('load', setup);
      onTick(function () {
        if (!on) return;
        var p = clamp((scroll.y - top) / distance, 0, 1);
        track.style.transform = 'translate3d(' + (-p * distance).toFixed(1) + 'px,0,0)';
      });
      // Teclado: si el foco entra en una tarjeta fuera de la vista, se desplaza la página hasta ella
      track.addEventListener('focusin', function (e) {
        if (!on) return;
        if (sticky) sticky.scrollLeft = 0;
        var card = e.target.closest('.pcard, .catalog__intro');
        if (!card) return;
        var need = clamp((card.offsetLeft + card.offsetWidth / 2 - window.innerWidth / 2) / distance, 0, 1);
        var y = top + need * distance;
        if (lenis) lenis.scrollTo(y, { immediate: true }); else window.scrollTo(0, y);
      });
    });
  }

  /* ---------- Catálogo en móvil: flechas, puntos y un pequeño empujón que enseña que se desliza ---------- */
  function initCatalogNav(scope) {
    $$('[data-hscroll]', scope).forEach(function (sec) {
      var track = $('[data-hscroll-track]', sec);
      var nav = $('[data-catalog-nav]', sec);
      if (!track || !nav || !once(nav, 'cnav')) return;
      var cards = $$('.pcard', track);
      var dots = $$('[data-catalog-dot]', nav);
      var prev = $('[data-catalog-prev]', nav), next = $('[data-catalog-next]', nav);
      if (!cards.length) return;
      nav.hidden = false;
      var current = 0, touched = false;
      function pinned() { return sec.classList.contains('is-pinned'); }
      function target(i) {
        var pad = parseFloat(getComputedStyle(track).scrollPaddingInlineStart || getComputedStyle(track).paddingLeft) || 0;
        return Math.max(0, cards[i].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - pad);
      }
      function go(i) {
        i = clamp(i, 0, cards.length - 1);
        touched = true;
        track.scrollTo({ left: target(i), behavior: reduce() ? 'auto' : 'smooth' });
      }
      function update() {
        if (pinned()) return;
        var x = track.scrollLeft, best = 0, bestD = Infinity;
        cards.forEach(function (c, i) { var dd = Math.abs(target(i) - x); if (dd < bestD) { bestD = dd; best = i; } });
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = cards.length - 1;
        current = best;
        dots.forEach(function (dt, i) {
          dt.classList.toggle('is-active', i === current);
          if (i === current) dt.setAttribute('aria-current', 'true'); else dt.removeAttribute('aria-current');
        });
        prev.disabled = current === 0;
        next.disabled = current === cards.length - 1;
      }
      var raf = 0;
      track.addEventListener('scroll', function () { if (!raf) raf = window.requestAnimationFrame(function () { raf = 0; update(); }); }, { passive: true });
      prev.addEventListener('click', function () { go(current - 1); });
      next.addEventListener('click', function () { go(current + 1); });
      dots.forEach(function (dt, i) { dt.addEventListener('click', function () { go(i); }); });
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, function () { touched = true; }, { passive: true }); });
      window.addEventListener('resize', update);
      update();
      // Empujón de una sola vez: al ver el catálogo, las tarjetas se asoman un poco y vuelven
      if (reduce() || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.disconnect();
          setTimeout(function () {
            if (touched || pinned() || track.scrollLeft > 4) return;
            track.style.scrollSnapType = 'none';
            track.scrollTo({ left: 72, behavior: 'smooth' });
            setTimeout(function () {
              if (!touched) track.scrollTo({ left: 0, behavior: 'smooth' });
              setTimeout(function () { track.style.scrollSnapType = ''; }, 600);
            }, 650);
          }, 700);
        });
      }, { threshold: 0.3 });
      io.observe(cards[0]);
    });
  }

  /* ---------- Preguntas: acordeón accesible con transición FLIP ---------- */
  function initAccordion(scope) {
    $$('[data-accordion]', scope).forEach(function (list) {
      if (!once(list, 'acc')) return;
      var btns = $$('.faq__btn', list);
      btns.forEach(function (b) { $('#' + b.getAttribute('aria-controls'), list).hidden = true; });

      function movers() {
        var after = [];
        var sec = list.closest('section');
        var n = sec ? sec.nextElementSibling : null;
        while (n) { after.push(n); n = n.nextElementSibling; }
        var foot = $('.site-footer');
        if (foot) after.push(foot);
        return $$('.faq__item', list).concat(after);
      }
      function toggle(btn) {
        var opening = btn.getAttribute('aria-expanded') !== 'true';
        var els = reduce() ? [] : movers();
        var first = els.map(function (el) { return el.getBoundingClientRect().top; });
        btns.forEach(function (b) {
          var p = $('#' + b.getAttribute('aria-controls'), list);
          var on = b === btn && opening;
          b.setAttribute('aria-expanded', on ? 'true' : 'false');
          b.closest('.faq__item').classList.toggle('is-open', on);
          p.hidden = !on;
        });
        if (reduce()) return;
        els.forEach(function (el, i) {
          var delta = first[i] - el.getBoundingClientRect().top;
          if (Math.abs(delta) < 1 || !el.animate) return;
          el.animate([{ transform: 'translate3d(0,' + delta + 'px,0)' }, { transform: 'translate3d(0,0,0)' }], { duration: 520, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
        });
        if (opening) {
          var ans = $('#' + btn.getAttribute('aria-controls'), list);
          if (ans.animate) ans.animate([{ opacity: 0, transform: 'translate3d(0,-10px,0)' }, { opacity: 1, transform: 'none' }], { duration: 420, easing: 'ease-out' });
        }
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { toggle(b); });
        b.addEventListener('keydown', function (e) {
          var to = null;
          if (e.key === 'ArrowDown') to = btns[(i + 1) % btns.length];
          else if (e.key === 'ArrowUp') to = btns[(i - 1 + btns.length) % btns.length];
          else if (e.key === 'Home') to = btns[0];
          else if (e.key === 'End') to = btns[btns.length - 1];
          if (to) { e.preventDefault(); to.focus(); }
        });
      });
    });
  }

  /* ---------- Llamada final: palabras que se revelan con el scroll ---------- */
  function initScrub(scope) {
    if (reduce()) return;
    $$('[data-scrub-words]', scope).forEach(function (el) {
      if (!once(el, 'scrub')) return;
      var words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      var spans = words.map(function (w, i) {
        var s = d.createElement('span');
        s.className = 'sw-word';
        s.textContent = w;
        el.appendChild(s);
        if (i < words.length - 1) el.appendChild(d.createTextNode(' '));
        return s;
      });
      var active = false;
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { active = en[0].isIntersecting; }).observe(el);
      else active = true;
      onTick(function () {
        if (!active) return;
        var r = el.getBoundingClientRect(), vh = window.innerHeight;
        var p = clamp((vh * 0.92 - r.top) / (vh * 0.55), 0, 1);
        var n = spans.length;
        for (var i = 0; i < n; i++) spans[i].style.setProperty('--o', clamp(p * n * 1.15 - i, 0.12, 1).toFixed(3));
      });
    });
  }

  /* ---------- Página de producto: variante → botón de compra directa ---------- */
  function initProduct(scope) {
    $$('[data-product]', scope).forEach(function (wrap) {
      var sel = $('[data-variant-select]', wrap), buy = $('[data-buy-now]', wrap), price = $('[data-product-price]', wrap);
      if (!sel || !once(wrap, 'prod')) return;
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (buy) buy.href = buy.getAttribute('data-cart-base') + '/' + sel.value + ':1';
        if (price && opt) price.textContent = opt.getAttribute('data-price');
      });
    });
  }

  /* ---------- Arranque ---------- */
  function initScope(scope) {
    safe('decode', function () { $$('[data-decode]', scope).forEach(splitDecode); });
    safe('reveal', function () { initReveal(scope); });
    window.H3_READY = true;
    safe('magnetic', function () { initMagnetic(scope); });
    safe('tilt', function () { initTilt(scope); });
    safe('parallax', function () { initParallax(scope); });
    safe('marquee', function () { initMarquee(scope); });
    safe('hscroll', function () { initHScroll(scope); });
    safe('catalognav', function () { initCatalogNav(scope); });
    safe('accordion', function () { initAccordion(scope); });
    safe('scrub', function () { initScrub(scope); });
    safe('product', function () { initProduct(scope); });
  }
  function boot() {
    safe('smooth', initSmooth);
    safe('chrome', initChrome);
    safe('cursor', initCursor);
    initScope(d);
    window.requestAnimationFrame(frame);
    d.addEventListener('shopify:section:load', function (e) { initScope(e.target); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
